// hook ที่ผูก type ของ store ไว้แล้ว — ใช้สองตัวนี้ทุกที่ ไม่เรียก useSelector ดิบ
import { useDispatch, useSelector } from "react-redux";
import type { AppDispatch, RootState } from "./store";

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
